import { render, staticRenderFns } from "./mgVipTip.vue?vue&type=template&id=0a59add4&scoped=true"
import script from "./mgVipTip.vue?vue&type=script&lang=js"
export * from "./mgVipTip.vue?vue&type=script&lang=js"
import style0 from "./mgVipTip.vue?vue&type=style&index=0&id=0a59add4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a59add4",
  null
  
)

export default component.exports